import {getTime} from '../utils'

function getError (action, option, xhr) {
  let msg
  console.log(xhr)
  console.log(xhr.responseText)
  let mes1 = JSON.parse(xhr.responseText)
  let mes2 = mes1.message
  if (xhr.response) {
    msg = `${xhr.status} ${xhr.response.error || xhr.response}`
  } else if (xhr.responseText) {
    msg = `${xhr.status} ${xhr.responseText}`
  } else {
    msg = `fail to post ${action} ${xhr.status}`
  }

  const err = new Error(msg)
  err.status = xhr.status
  err.method = 'post'
  err.url = action
  if (mes2 === '目标文件夹禁止此操作') {
    err.message = 450
  } else {
    err.message = xhr.status
  }
  err.code = -200
  return err
}

function getBody (xhr) {
  const text = xhr.responseText || xhr.response
  if (!text) {
    return text
  }

  try {
    return JSON.parse(text)
  } catch (e) {
    return text
  }
}

export default function upload (option) {
  if (typeof XMLHttpRequest === 'undefined') {
    return
  }

  const xhr = new XMLHttpRequest()
  const action = option.action

  let begin = new Date().getTime()

  if (xhr.upload) {
    xhr.upload.onprogress = function progress (e) {
      if (e.total > 0) {
        let now = new Date().getTime()
        let dValue = now - begin
        let res = e.total / (e.loaded / dValue) - dValue
        e.time = getTime(res)
        e.percent = e.loaded / e.total * 100
      }
      option.onProgress(e)
    }
  }

  const formData = new FormData()

  if (option.data) {
    Object.keys(option.data).map(key => {
      formData.append(key, option.data[key])
    })
  }

  formData.append(option.filename, option.file)

  xhr.onerror = function error (e) {
    const err = new Error()
    if (e.target.status < 200 || e.target.status >= 300) {
      err.code = -200
      err.message = e.target.status
    } else {
      err.code = -220
      err.message = 'IO error'
    }

    option.onError(err)
  }

  xhr.onload = function onload () {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr))
    }

    option.onSuccess(getBody(xhr))
  }

  /**
   * 如果serial为true，在请求complete时无论成功与否，开始上传下一个文件
   */

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      option.onComplete(option.file, xhr)
    }
  }

  xhr.open('post', action, true)

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true
  }

  const headers = option.headers || {}

  for (let item in headers) {
    if (headers.hasOwnProperty(item) && headers[item] !== null) {
      xhr.setRequestHeader(item, headers[item])
    }
  }
  xhr.send(formData)
  return xhr
}



// WEBPACK FOOTER //
// ./src/components/upload/upload_vue/upload-ajax.js